import { render, staticRenderFns } from "./CompRatingStars.vue?vue&type=template&id=1d4ba623&scoped=true"
import script from "./CompRatingStars.vue?vue&type=script&setup=true&lang=js"
export * from "./CompRatingStars.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CompRatingStars.vue?vue&type=style&index=0&id=1d4ba623&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4ba623",
  null
  
)

export default component.exports